import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

export const myCustomPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{sky.50}',
      100: '{sky.100}',
      200: '{sky.200}',
      300: '{sky.300}',
      400: '{sky.400}',
      500: '{sky.500}',
      600: '{sky.500}',
      700: '{sky.500}',
      800: '{sky.500}',
      900: '{sky.500}',
      950: '{sky.500}',
    },
    colorScheme: {
      light: {
        primary: {
          color: '{sky.500}',
          contrastColor: '#ffffff',
          hoverColor: '{sky.500}',
          activeColor: '{sky.500}',
        },
        highlight: {
          background: '{sky.500}',
          focusBackground: '{sky.500}',
          color: '#ffffff',
          focusColor: '#ffffff',
        },
      },
    },
  },
});
